var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-notice",staticStyle:{"z-index":"9999"}},_vm._l((_vm.notices),function(notice){return _c('notice',{key:notice.name,attrs:{"name":notice.name,"type":notice.type,"duration":notice.duration,"content":notice.content,"on-close":notice.onClose,"render":notice.render}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dddb774","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/notification/notification.vue
// module id = null
// module chunks = 